import {
	IonContent,
	IonHeader,
	IonItem,
	IonList,
	IonMenu,
	IonTitle,
	IonToolbar,
} from "@ionic/react";
import { useTranslation } from "react-i18next";

const WithMenu = ({ children }) => {
	const { t, i18n } = useTranslation();

	return (
		<>
			<IonMenu side="start" contentId="home-app">
				<IonHeader>
					<IonToolbar color="primary">
						<IonTitle>TVM</IonTitle>
					</IonToolbar>
				</IonHeader>
				<IonContent>
					<IonList>
						<IonItem routerLink="/settings">{t("menu.settings")}</IonItem>
						<IonItem routerLink="/about">{t("menu.about")}</IonItem>
					</IonList>
				</IonContent>
			</IonMenu>
			{children}
		</>
	);
};

export default WithMenu;
